export const deepFreeze = source => {
  if (source && (typeof source === 'object' || typeof source === 'function') && !Object.isFrozen(source)) {
    Object.freeze(source);
    Object.getOwnPropertyNames(source).forEach(prop => deepFreeze(source[prop]));
  }
  return source;
};